// extracted by mini-css-extract-plugin
export var sliderRange = "_rs-2";
export var sliderRoot = "_rs-0";
export var sliderThumb = "_rs-3";
export var sliderTrack = "_rs-1";